'use strict';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Plugin = require('./plugin');

module.exports = function (_Plugin) {
  _inherits(Pinch, _Plugin);
  /**
   * @private
   * @param {Viewport} parent
   * @param {object} [options]
   * @param {boolean} [options.noDrag] disable two-finger dragging
   * @param {number} [options.percent=1.0] percent to modify pinch speed
   * @param {PIXI.Point} [options.center] place this point at center during zoom instead of center of two fingers
   */


  function Pinch(parent, options) {
    _classCallCheck(this, Pinch);

    var _this = _possibleConstructorReturn(this, (Pinch.__proto__ || Object.getPrototypeOf(Pinch)).call(this, parent));

    options = options || {};
    _this.percent = options.percent || 1.0;
    _this.noDrag = options.noDrag;
    _this.center = options.center;
    return _this;
  }

  _createClass(Pinch, [{
    key: 'down',
    value: function down() {
      if (this.parent.countDownPointers() >= 2) {
        this.active = true;
        return true;
      }
    }
  }, {
    key: 'move',
    value: function move(e) {
      if (this.paused || !this.active) {
        return;
      }

      var x = e.data.global.x;
      var y = e.data.global.y;
      var pointers = this.parent.getTouchPointers();

      if (pointers.length >= 2) {
        var first = pointers[0];
        var second = pointers[1];
        var last = first.last && second.last ? Math.sqrt(Math.pow(second.last.x - first.last.x, 2) + Math.pow(second.last.y - first.last.y, 2)) : null;

        if (first.pointerId === e.data.pointerId) {
          first.last = {
            x: x,
            y: y,
            data: e.data
          };
        } else if (second.pointerId === e.data.pointerId) {
          second.last = {
            x: x,
            y: y,
            data: e.data
          };
        }

        if (last) {
          var oldPoint = void 0;
          var point = {
            x: first.last.x + (second.last.x - first.last.x) / 2,
            y: first.last.y + (second.last.y - first.last.y) / 2
          };

          if (!this.center) {
            oldPoint = this.parent.toLocal(point);
          }

          var dist = Math.sqrt(Math.pow(second.last.x - first.last.x, 2) + Math.pow(second.last.y - first.last.y, 2));
          var change = (dist - last) / this.parent.screenWidth * this.parent.scale.x * this.percent;
          this.parent.scale.x += change;
          this.parent.scale.y += change;
          this.parent.emit('zoomed', {
            viewport: this.parent,
            type: 'pinch'
          });
          var clamp = this.parent.plugins['clamp-zoom'];

          if (clamp) {
            clamp.clamp();
          }

          if (this.center) {
            this.parent.moveCenter(this.center);
          } else {
            var newPoint = this.parent.toGlobal(oldPoint);
            this.parent.x += point.x - newPoint.x;
            this.parent.y += point.y - newPoint.y;
            this.parent.emit('moved', {
              viewport: this.parent,
              type: 'pinch'
            });
          }

          if (!this.noDrag && this.lastCenter) {
            this.parent.x += point.x - this.lastCenter.x;
            this.parent.y += point.y - this.lastCenter.y;
            this.parent.emit('moved', {
              viewport: this.parent,
              type: 'pinch'
            });
          }

          this.lastCenter = point;
          this.moved = true;
        } else {
          if (!this.pinching) {
            this.parent.emit('pinch-start', this.parent);
            this.pinching = true;
          }
        }

        return true;
      }
    }
  }, {
    key: 'up',
    value: function up() {
      if (this.pinching) {
        if (this.parent.touches.length <= 1) {
          this.active = false;
          this.lastCenter = null;
          this.pinching = false;
          this.moved = false;
          this.parent.emit('pinch-end', this.parent);
          return true;
        }
      }
    }
  }]);

  return Pinch;
}(Plugin);